import { QueryBoundary, Loader } from '@mews-commander/ui';
import { SentryTeams } from '@mews/enums';
import { SentryErrorBoundary } from '@mews/framework';
import { LedgerActivityReport } from './components/LedgerActivityReport';

export { urlSearchSchema } from './schema';

export const LedgerActivityReportPage = () => {
    return (
        <SentryErrorBoundary team={SentryTeams.Accounting} fallback={<Loader />}>
            <QueryBoundary>
                <LedgerActivityReport />
            </QueryBoundary>
        </SentryErrorBoundary>
    );
};
